import './ContextPane.scss'
import { Menu } from '../Menu'
import SupportMenu from '../SupportMenu/SupportMenu'

export type ContextPaneProps = {
  setSupport: (key: string) => void
}

export function ContextPane(props: ContextPaneProps) {
  return (
    <div className="ux-context-pane !h-[calc(100vh-86px)]">
      <section className="menu">
        <Menu />
      </section>
      <section className="py-5 pr-5">
        <div className="rounded-lg bg-grey-lighterer p-2">
          <SupportMenu setSupport={props.setSupport} />
        </div>
      </section>
    </div>
  )
}
